import { getCourseCertificate } from "../api";
import { useApiGet } from "@/hooks/useApi";

export function useGetCourseCertificate(slug, { enabled = true } = {}) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["certificates", "course", `${slug}`],
		fn: () => getCourseCertificate(slug),
		options: {
			enabled: enabled && Boolean(slug),
			refetchInterval: (queryData) => {
				const currentData = queryData?.state?.data;
				if (
					currentData &&
					currentData?.certificate?.is_unlocked &&
					currentData?.image_png == null
				) {
					return 500; // Refetch twice per second while the image is generating
				}

				return null;
			},
		},
	});

	const { certificate } = data || { certificate: [] };

	return { certificate, isPending, isSuccess, isError, error };
}
